import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  card: {
    minWidth: 275,
    backgroundColor: "var(--primaryColor)"
  },
  title: {
    fontSize: "40px"
  },
  pos: {
    marginBottom: 12
  },
  text: {
    fontSize: "25px"
  }
});
